import React from 'react';
import { TRAIN_AGENT_LOOM_VIDEO_IDS } from './trainAgentConstants';

export function TrainAgentHelpVideos() {
  return (
    <section
      style={{
        position: 'relative',
        zIndex: 0,
        marginTop: 48,
        paddingTop: 24,
        borderTop: '1px solid rgba(0, 212, 255, 0.2)'
      }}
    >
      <h3
        style={{
          color: '#00D4FF',
          fontSize: '1rem',
          fontWeight: 600,
          marginBottom: 16,
          textTransform: 'uppercase',
          letterSpacing: 1
        }}
      >
        Vídeos de ajuda
      </h3>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))', gap: 24 }}>
        {TRAIN_AGENT_LOOM_VIDEO_IDS.map((vid, i) => (
          <div
            key={vid}
            style={{
              position: 'relative',
              paddingBottom: '56.25%',
              height: 0,
              overflow: 'hidden',
              borderRadius: 12,
              border: '1px solid rgba(0, 212, 255, 0.3)'
            }}
          >
            <iframe
              title={`Treine seu agente parte ${i + 1}`}
              src={`https://www.loom.com/embed/${vid}`}
              style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
              frameBorder="0"
              allow="fullscreen"
              allowFullScreen
            />
          </div>
        ))}
      </div>
    </section>
  );
}
